import React from 'react';
import { CatalogueMismatchError } from 'src/pages/Suite/Components/UnitImportDialogue/Hooks/Helpers/rowValidationHelpers';
import './AssetCatalogueMismatchCard.scss';
import { variables } from 'src/Tenants';

interface AssetCatalogueMismatchCardProps {
  mismatch: CatalogueMismatchError;
}

const AssetCatalogueMismatchCard = ({ mismatch }: AssetCatalogueMismatchCardProps) => (
  <div className="asset-mismatch-card">
    <div className="asset-mismatch-card-header">
      <div className="asset-mismatch-card-title">
        {mismatch.unmatchedCsvAssets.length} asset{mismatch.unmatchedCsvAssets.length !== 1 ? 's' : ''} in your CSV don't match the property catalogue
      </div>
      <div className="asset-mismatch-card-subtitle">
        The assets below aren't in this property's catalogue. Add them to the catalogue and assign them to this property first, then re-upload your CSV.
      </div>
    </div>
    <div className="asset-mismatch-card-columns">
      <div className="asset-mismatch-col">
        <div className="asset-mismatch-col-label">Not found in the catalogue for this {variables.suite}</div>
        <div className="asset-mismatch-chip-list">
          {mismatch.unmatchedCsvAssets.map((name: string) => (
            <span key={name} className="asset-mismatch-chip asset-mismatch-chip--invalid">
              {name}
            </span>
          ))}
        </div>
      </div>
      <div className="asset-mismatch-divider" />
      <div className="asset-mismatch-col">
        <div className="asset-mismatch-col-label">Available in the catalogue for this {variables.suite}</div>
        <div className="asset-mismatch-chip-list">
          {mismatch.catalogueItemNames.map((name: string) => (
            <span key={name} className="asset-mismatch-chip asset-mismatch-chip--valid">
              {name}
            </span>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default AssetCatalogueMismatchCard;